import React from "react";

export default function BurgerModal() {
  return (
    <div className="w-[100%] h-[500px] absolute bg-[#2F5059]">
      <ul className="flex items-center gap-8 m-[2%] flex-col">
        <li className="cursor-pointer bg-[#4E9C7F] w-[100%] flex rounded-[199px] justify-center items-center h-[50px] ">
          <a href="/" className="font-main text-white text-lg  ">
            Anime portrais
          </a>
        </li>
        <li className="cursor-pointer bg-[#4E9C7F] w-[100%] flex rounded-[199px] justify-center items-center h-[50px]">
          <a href="/" className="font-main text-white text-lg  ">
            Storybooks
          </a>
        </li>
        <li className="cursor-pointer bg-[#4E9C7F] w-[100%] flex rounded-[199px] justify-center items-center h-[50px]">
          <a href="/" className="font-main text-white text-lg  ">
            AI Avatars
          </a>
        </li>
        <li className="cursor-pointer bg-[#4E9C7F] w-[100%] flex rounded-[199px] justify-center items-center h-[50px]">
          <a href="/" className="font-main text-white text-lg">
            Blog
          </a>
        </li>
        <li className="cursor-pointer bg-[#4E9C7F] w-[100%] flex rounded-[199px] justify-center items-center h-[50px]">
          <a href="/" className="font-main text-white text-lg">
            Order tracking
          </a>
        </li>
      </ul>
    </div>
  );
}
